import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    logoName: '',
  },
  getters: {
  },
  mutations: {
    CHANGE_TITLE(state, title) {
      document.title = title
      state.logoName = title
    }
  },
  actions: {
  },
  modules: {
  }
})
